import { ReviewSubjectType } from './review';

export interface ReviewSubjectOption {
  label: string;
  value: ReviewSubjectType;
}

export const REVIEW_SUBJECT_OPTIONS: ReviewSubjectOption[] = [
  { label: 'Cancellation', value: ReviewSubjectType.Cancellation },
  { label: 'Walkout', value: ReviewSubjectType.Walkout },
  { label: 'Sideloaded', value: ReviewSubjectType.Sideloaded },
  { label: 'Deepdive', value: ReviewSubjectType.Deepdive },
  { label: 'Underringing', value: ReviewSubjectType.Underringing },
];

export type LpQueueType = 'Investigation' | 'Validation';

export interface LpQueue {
  id: string;
  name: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  sort_by?: string;
  num_branches?: number;
  num_locations?: number;
  type: LpQueueType;
  additional_submissions?: boolean;
  limit_incident_delivery?: boolean;
}
